import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col, Button } from 'react-bootstrap';

import List from 'components/List';

import Loader from 'components/layout/Loader';

// show information for the user that he may activate plugins if he has the rights to do so
class DashboardInitPlugins extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDetails: false,
      detailsPlugin: null,
      showSettings: false,
      settingsPlugin: null,
      showActivate: false,
      showTerminate: false,
      selectedWhiteLabel: null,
    };
  }

  componentDidUpdate = prevProps => {
    const {
      intl: { messages },
      pluginSettingsFormStatus,
      doNotify,
    } = this.props;
    const { selectedWhiteLabel } = this.state;

    if (
      prevProps.pluginSettingsFormStatus.pending &&
      !pluginSettingsFormStatus.pending &&
      !pluginSettingsFormStatus.hasError
    ) {
      doNotify(1, messages.settings_saved);

      if (selectedWhiteLabel.id === pluginSettingsFormStatus.response.id) {
        this.setState({ showSettings: false, selectedWhiteLabel: pluginSettingsFormStatus.response });
      } else {
        this.setState({ showSettings: false });
      }
    }
  };

  componentDidMount = () => {
    this.setState({
      selectedWhiteLabel: this.props.myWhiteLabelProject.data.list.length
        ? this.props.myWhiteLabelProject.data.list[0]
        : null,
    });
  };

  showDetails = detailsPlugin => {
    this.setState({ showDetails: true, detailsPlugin });
  };

  closePopup = () => {
    this.setState({ showDetails: false, showActivate: false, showTerminate: false, showSettings: false });
  };

  render() {
    const {
      intl: { messages },
      appIntl,
      history,
      list,
    } = this.props;
    const { selectedWhiteLabel } = this.state;

    return (
      <div class="jumbotron">
        <List noRender listName="whiteLabelPlugin" url="/api/whitelabelplugins.json" list={list} />
        {!!selectedWhiteLabel && (
          <React.Fragment>
            <List
              noRender
              listName="pluginActivationRequests"
              url={'/api/whitelabels/' + selectedWhiteLabel.id + '/pluginActivationRequests.json'}
              list={this.props.pluginActivationRequests}
            />
            <List
              noRender
              listName="pluginTerminationRequests"
              url={'/api/whitelabels/' + selectedWhiteLabel.id + '/pluginTerminationRequests.json'}
              list={this.props.pluginTerminationRequests}
            />
          </React.Fragment>
        )}

        <Grid fluid class="m-b-20 m-t-20">
          <Row>
            <Col lg={6} class="bg-white">
              <div class="padding-30 text-center">Nice video here</div>
            </Col>
            <Col lg={6}>
              <div class="card card-transparent">
                <div class="card-header">
                  <div class="card-title">{messages.getting_started}</div>
                </div>
                <div class="card-block">
                  <h3>{messages.plugins}</h3>
                  <p>
                    Sie können die Funktionalität Ihrer neuen Plattform selbst auswählen. Hier ist eine Liste unserer
                    wichtigsten Plugins:
                  </p>

                  {list.pending ? (
                    <Loader />
                  ) : (
                    <div class="p-l-15 m-t-20 hint-text">
                      {list.data.list.map((plugin, i) => {
                        if (!plugin.dependent_on) {
                          return <div key={i}>{plugin.name}</div>;
                        }
                      })}
                    </div>
                  )}

                  <p class="m-t-20">
                    Sie haben jetzt die Möglichkeit, Plugins zu aktivieren. Weitere Informationen zu unseren Plugins
                    finden Sie in den Einstellungen. Klicken Sie auf Ihren Profilnamen (oben rechts), dann auf
                    Einstellungen und Plugins oder klicken Sie auf die Schaltfläche unten.
                  </p>
                  <div class="text-right p-t-15">
                    <Button
                      bsStyle="primary"
                      onClick={() => history.push(appIntl.urlPrefix + 'account/settings/plugins')}
                    >
                      <i class="fa fa-plug m-r-10" /> {messages.settings}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    list: state.list.whiteLabelPlugin,
    pluginActivationRequests: state.list.pluginActivationRequests,
    pluginTerminationRequests: state.list.pluginTerminationRequests,
    pluginTerminateFormStatus: state.formStatus.pluginTerminate,
    pluginActivateFormStatus: state.formStatus.pluginActivate,
    pluginSettingsFormStatus: state.formStatus.pluginSettingsEdit,
  };
};

export default withRouter(injectIntl(connect(mapStateToProps)(DashboardInitPlugins)));
